export default "__VITE_ASSET__7b4de84b__"